import React, { useContext } from "react";
import { motion } from "motion/react";

import { serviceData } from "../constants";
import { ThemeContext } from "../themeProvider";

const Experience = () => {
  const { state } = useContext(ThemeContext);
  return (
    <div
      className={`
        py-20
        ${state.darkMode ? " bg-black" : " bg-white"}`
      }
    >
      <div
        className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12"
        id="experience"
      >
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <span className={`inline-block px-4 py-2 rounded-full text-sm font-semibold mb-4 ${
            state.darkMode ? 'bg-blue-500/20 text-blue-400' : 'bg-blue-100 text-blue-600'
          }`}>
            What I Do
          </span>
          <h2 className={`text-5xl md:text-6xl font-bold ${
            state.darkMode ? 'text-white' : 'text-gray-900'
          }`}>
            Experience & Expertise
          </h2>
        </motion.div>
        <div className="">
          <div className="grid md:grid-cols-3 gap-8">
            {serviceData.map((el, index) => (
              <motion.div
                key={el.name}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
                whileHover={{ y: -10 }}
                className={`
                  p-8 rounded-2xl flex flex-col transition-all duration-300
                  ${state.darkMode
                  ? " bg-gray-900 hover:bg-gray-800 shadow-xl hover:shadow-2xl hover:shadow-blue-500/20"
                  : " bg-gray-50 hover:bg-white shadow-lg hover:shadow-2xl hover:shadow-blue-500/10"
                }`}
              >
                <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-purple-600 rounded-2xl flex items-center justify-center mb-6">
                  <img src={el.img} alt="" className="w-10 h-10" />
                </div>
                <h4 className={`text-2xl font-bold mb-4 ${
                  state.darkMode ? 'text-white' : 'text-gray-900'
                }`}>{el.name}</h4>
                <p className={`text-base leading-relaxed text-justify ${
                  state.darkMode ? 'text-gray-400' : 'text-gray-600'
                }`}>{el.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Experience;
